import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDatepickerInputEvent, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { UserService } from '../services/user.service';
import * as moment from 'moment';
import { TableUtil } from '../admintrademaster/tableUtil';
@Component({
    selector: 'app-positionbook',
    templateUrl: './positionbook.component.html',
    styleUrls: ['./positionbook.component.css']
})
export class PositionBookComponent implements OnInit {
    displayedColumns = ['pair', 'position_date', 'matched_position', 'open_position', 'open_position_side', 'average_price', 'market_price', 'unrealized_pnl', 'realized_pnl', 'createdAt', 'updatedAt'];   
    public dataSource: any = new MatTableDataSource();
    pageSize = 20;
    @ViewChild('paginator') paginator: MatPaginator;
    @ViewChild('sort') sort: MatSort;
    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    constructor(private userService: UserService,) {
    }

    ngOnInit() {
        this.positionbooks();
        this.csrf();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    ngAfterViewInit() {
        if (this.paginator && this.sort) {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        }
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    async applyFilterDate() {
        await this.positionbooks();
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    async positionbooks() {
        await this.userService.csrf().subscribe(async (success) => {
            this.filter["_csrf"] = success._csrf;
            await this.userService.getPositionBooks(this.filter).subscribe(async positions => {
                if (positions) {
                    let response = positions.map(position => {
                        position.position_date = moment(position.position_date).format('YYYY-MM-DD')
                        position.createdAt = moment(position.createdAt).format('YYYY-MM-DD HH:mm:ss A')
                        position.updatedAt = moment(position.updatedAt).format('YYYY-MM-DD HH:mm:ss A')
                        return position;
                    })
                    this.dataSource.data = response;
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                }
            })
        })
    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
    async exportArray(data = null) {
        if (this.dataSource.filteredData) {
            const PositionBook = await this.dataSource.filteredData.map(x => ({
                pair: x.pair,
                position_date: x.position_date,
                matched_position: x.matched_position,
                open_position: x.open_position,
                open_position_side: x.open_position_side,
                average_price: x.average_price,
                market_price: x.market_price,
                unrealized_pnl: x.unrealized_pnl,
                realized_pnl: x.realized_pnl,
                createdAt: x.createdAt,
                updatedAt: x.updatedAt,
            }));
            TableUtil.exportArrayToExcel(PositionBook, "PositionBook");
        }

    }


}

export interface PositionBookData {
    pair: string,
    position_date: string,
    matched_position: number,
    open_position: number,
    open_position_side: string,
    average_price: number,
    market_price: number,
    unrealized_pnl: number,
    realized_pnl: number,
    createdAt: string,
    updatedAt: string,

}



// WEBPACK FOOTER //
// ./src/app/positionbook/positionbook.component.ts